module.exports = __webpack_public_path__ + "img/uk.ff3d53e7.jpg";